import React, { useEffect, useRef, useState } from 'react'
import { getBoundingClientRect } from 'front-end-core/helpers/document'
import cx from 'classnames'
import TransitionGroup from 'react-addons-css-transition-group'
import usePopover from 'hooks/usePopover'

// Used for Glossary Terms
const Popover = () => {
  const { containerRef, click, hover, resize, getBoundingBox } = usePopover()

  return (
    <div className='popover-container relative h0 z10' ref={containerRef}>
      <TransitionGroup
        transitionName='fade'
        transitionEnter={false}
        transitionLeave
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}
        component='div'
      >
        {[...click, ...hover].map((item, idx) => (
          <PopoverItem {...{ ...item, resize, getBoundingBox }} key={idx} />
        ))}
      </TransitionGroup>
    </div>
  )
}

export default Popover

const PopoverItem = ({ getBoundingBox, ...props }) => {
  const [glossaryPosition, setGlossaryPosition] = useState({ bottom: 0, left: 0, width: 0 })
  const [arrow, setArrow] = useState(0)
  const [left, setLeft] = useState(0)
  const [show, setShow] = useState(false)
  const popoverRef = useRef(null)
  const boundingBox = getBoundingBox()

  useEffect(() => {
    const { bottom, left, width } = getBoundingClientRect(props.el)
    setGlossaryPosition({ bottom, left, width })
  }, [props.el, props.resize])

  useEffect(() => {
    const { width } = getBoundingClientRect(popoverRef.current)
    const left = Math.min(
      Math.max(
        0,
        glossaryPosition.left + glossaryPosition.width / 2 - width / 2 - boundingBox.left
      ),
      boundingBox.width - width
    )
    const arrow = glossaryPosition.left + glossaryPosition.width / 2 - boundingBox.left - left
    setArrow(arrow)
    setLeft(left)
    setShow(true)
  }, [glossaryPosition])

  const style = {
    top: glossaryPosition.bottom - boundingBox.top,
    left,
    borderStyle: 'hidden'
  }

  const className = cx(
    'br2 pa0 popover bottom z10 absolute top-100 db o-0 default-cursor',
    { show }
  )

  return (
    <div {...{ className, style }} ref={popoverRef}>
      <div
        className='arrow'
        style={{
          left: arrow,
          borderBottomColor: 'darkblue'
        }}
      />
      <div
        className='f6 fw4 br2 bg-teal white popover-content pa4'
        dangerouslySetInnerHTML={{ __html: props.content }}
      />
    </div>
  )
}
